<template>
    <div class="import-show-screen">
        <h2 class="title">
            Find your Podcast
        </h2>

        <p class="description">
            To get started, paste your podcast's RSS feed below.<br>
            It is typically found inside your podcast host's dashboard.
        </p>

        <form class="form" @submit.prevent="handleSubmit">
            <FormRow
                id="feed-url"
                label="Enter your show RSS URL"
                :error="getValidationError('feedUrl')"
            >
                <FormInput
                    id="feed-url"
                    v-model="feedUrl"
                    type="text"
                    :disabled="isSubmitting"
                    autocomplete="off"
                    :error="hasValidationError('feedUrl')"
                    @focus="clearValidationError('feedUrl')"
                />
            </FormRow>

            <FormButton
                type="submit"
                class="submitButton is-purple"
                :is-loading="isSubmitting"
                text="Search"
            />
        </form>

        <a class="help" target="_blank" :href="helpFeedUrl">
            I need help finding my RSS Feed.
        </a>
    </div>
</template>
<script>
import apiCall from '@/utils/apiCall';
import formValidation from '@/mixins/formValidation';
import { FormButton, FormInput, FormRow } from '@/components/Form';
import { HELP_FEED_URL } from './../config';
import { validateFeedUrl } from '@/utils/form/showValidation';

export default {
    components: {
        FormButton,
        FormInput,
        FormRow,
    },

    mixins: [
        formValidation,
    ],

    props: {
        onSubmit: {
            required: true,
            type: Function,
        },
    },

    data: () => ({
        isSubmitting: false,
        feedUrl: '',
    }),

    computed: {
        /**
         * Gets the help URL.
         *
         * @returns {string} Help URL
         */
        helpFeedUrl() {
            return HELP_FEED_URL;
        },

        /**
         * Gets the list of field validators.
         *
         * @returns {object} Field validators.
         */
        fieldValidators() {
            return { feedUrl: (value) => validateFeedUrl(value) };
        },
    },

    methods: {
        /**
         * Handles submit.
         */
        async handleSubmit() {
            if (! await this.validate()) {
                return;
            }

            this.isSubmitting = true;
            const { status, data } = await apiCall(this, 'post', '/api/shows/import', { feedUrl: this.feedUrl });
            this.isSubmitting = false;

            if (400 <= status) {
                this.populateValidationErrors(data.errors ?? {});

                return;
            }

            this.onSubmit(data);
        },

        /**
         * Validates form.
         *
         * @returns {boolean} Validation result.
         */
        async validate() {
            this.clearValidationErrors();

            await this.validateForm({ feedUrl: this.feedUrl }, this.fieldValidators);

            if (this.hasValidationErrors()) {
                return false;
            }

            return true;
        },
    },
};
</script>
<style scoped lang="scss">
    @use './ImportShowScreen.scss';
</style>
